import { MODIFICATION_ID, STACK_ID, COMPARATOR_VERSION_ID, COMPARATOR_PROJECT_ID } from "const/routeParams";
import { DATASETS_PATH } from "const/routes";

export const createStackUrl = (stackId: number, projectId: number, versionId: string, modificationId?: number) =>
  modificationId
    ? `${DATASETS_PATH}/${projectId}/${versionId}?${MODIFICATION_ID}=${modificationId}&${STACK_ID}=${stackId}`
    : `${DATASETS_PATH}/${projectId}/${versionId}?${STACK_ID}=${stackId}`;

export const createModificationUrl = (modificationId: number, projectId: number, versionId: string) =>
  `${DATASETS_PATH}/${projectId}/${versionId}?${MODIFICATION_ID}=${modificationId}`;

export const createProjectRootUrl = (projectId: number, versionId?: string) => {
  const url = `${DATASETS_PATH}/${projectId}`;
  return versionId ? `${url}/${versionId}` : url;
};

export const createImportInstructionsUrl = (projectId: number, versionId: string, sourcePojectId: number, sourceModificationId: number) => {
  return `${DATASETS_PATH}/${projectId}/${versionId}/import?sourceProjectId=${sourcePojectId}&sourceModificationId=${sourceModificationId}`;
};

export const selectedvariableOECodingViewUrl = (projectId: number, versionId: string, variableFullName: string) => {
  return `${DATASETS_PATH}/${projectId}/${versionId}/oe-coding/${encodeURIComponent(variableFullName || "")}`;
};

export const compareViewUrl = (referenceProjectId: string, versionId: string, comparatorVersionId: string) => {
  return `${DATASETS_PATH}/${referenceProjectId}/${versionId}/compare/${comparatorVersionId}`;
};

export const compareSelectionUrl = (
  referenceProjectId: string,
  versionId: string,
  comparatorProjectId?: string,
  comparatorVersionId?: string,
) => {
  if (comparatorVersionId && comparatorProjectId) {
    return `${DATASETS_PATH}/${referenceProjectId}/${versionId}/selection?${COMPARATOR_PROJECT_ID}=${comparatorProjectId}&${COMPARATOR_VERSION_ID}=${comparatorVersionId}`;
  }
  return `${DATASETS_PATH}/${referenceProjectId}/${versionId}/selection`;
};
